import { render, staticRenderFns } from "./ClipIcon.vue?vue&type=template&id=9721a048&scoped=true"
var script = {}
import style0 from "./ClipIcon.vue?vue&type=style&index=0&id=9721a048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9721a048",
  null
  
)

export default component.exports